<template>
    <div class="node">
        <div 
            class="d-flex" 
            :class="highlight ? 'bg-border-gray' : ''"
            @mouseover="() => highlight = true" 
            @mouseleave="() => highlight = false"
        >
            <div v-for="(i) in level" :key="i" class="w-30"></div>
            <div>
                <!-- 收合按鈕 -->
                <button 
                    v-if="!node.coverage"
                    class="btn btn-sm btn-text text-green mx-0 w-30" 
                    :disabled="!(node.children && node.children.length)"
                    @click.stop.prevent="changeExpanded()"
                >
                    <i v-if="isExpanded" class="fas fa-caret-down"></i>
                    <i v-else class="fas fa-caret-right"></i>
                </button>
            </div>
            <div class="flex-grow-1">
                <!-- 編輯模式 -->
                <template v-if="isEditMode && !node.coverage">
                    <input v-model="editCode" class="form-control form-control-inline form-short h-26 my-1" type="text">
                    <input v-model="editCategory" class="form-control form-control-inline h-26 my-1" type="text">
                </template>
                <!-- 預覽模式(保障階層為綠色粗體字) -->
                <template v-else>
                    <div class="d-inline-block lh-18 p-2" :class="node.coverage ? '' : 'text-green text-bold'">{{ node.code }}</div>
                    <div class="d-inline-block lh-18 p-2" :class="node.coverage ? '' : 'text-green text-bold'">{{ node.category }}</div>
                </template>
            </div>
            <!-- 按鈕區 -->
            <div :class="highlight ? '' : 'd-none'">
                <!-- 編輯 -->
                <button
                    class="btn btn-sm btn-text mx-0 px-1"
                    @click.stop.prevent="editNode()"
                    :disabled="node.isother"
                >
                    <i v-if="isEditMode" class="fas fa-check"></i>
                    <i v-else class="fas fa-edit"></i>
                </button>
                <!-- 上移 -->
                <button class="btn btn-sm btn-text mx-0 px-1" @click.stop.prevent="moveUp()" :disabled="isFirst">
                    <i class="fas fa-arrow-alt-circle-up"></i>
                </button>
                <!-- 下移 -->
                <button class="btn btn-sm btn-text mx-0 px-1" @click.stop.prevent="moveDown()" :disabled="isLast">
                    <i class="fas fa-arrow-alt-circle-down"></i>
                </button>
                <!-- 刪除 -->
                <button class="btn btn-sm btn-text mx-0 px-1" @click.stop.prevent="deleteNode()">
                    <i class="fas fa-trash-alt"></i>
                </button>
            </div>
        </div>
        <!-- 子節點 -->
        <div v-if="node.children && node.children.length" v-show="isExpanded">
            <report-setting-tree-node
                v-for="(child, index) in node.children"
                :key="index"
                :node="child"
                :siblings="node.children"
                :level="level+1"
                :expanded="expanded"
                :isFirst="index == 0"
                :isLast="index == node.children.length-1"
                @delete="onDelete"
                @editCoverage="onEditCoverage"
                @beforeModifyNode="onBeforeModifyNode"
            ></report-setting-tree-node>
        </div>
    </div>
</template>

<script>
export default {
    name: "ReportSettingTreeNode",
    props: {
        // code: { type: String, required: true, },
        // category: { type: String, required: true, },
        // children: { type: Array, required: true, default: () => [] },
        node: {
            type: Object,
            required: true,
            default: () => {}
        },
        siblings: {
            type: Array, 
            required: true, 
            default: () => [] 
        },
        level: {
            type: Number,
            required: false,
            default: 0,
        },
        expanded: {
            type: Boolean,
            required: false,
            default: false,
        },
        isFirst: {
            type: Boolean,
            required: false,
            default: false,
        },
        isLast: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            isExpanded: true,
            isEditMode: false,
            editCode: "",
            editCategory: "",
            highlight: false,
        };
    },
    watch: {
        expanded(value) {
            this.isExpanded = value
        },
    },
    methods: {
        // 控制收合
        changeExpanded() {
            this.isExpanded = !this.isExpanded;
        },
        // 編輯節點
        editNode() {
            if (this.node.coverage) {
                // 如果是中項保障群組，要開啟彈窗編輯(使用emit在ReportSetting控制彈窗)
                this.$emit('editCoverage', [{
                    code:this.node.code, 
                    category:this.node.category,
                    coverage:this.node.coverage,
                    coveragename:this.node.coveragename,
                    detail:this.node.detail,
                    detailname:this.node.detailname,
                }])
            } else {
                // 如果是保障階層，則直接切換為input做編輯
                if (this.isEditMode) {
                    this.$emit('beforeModifyNode', 'edit');
                    this.node.code = this.editCode;
                    this.node.category = this.editCategory;
                } else {
                    this.editCode = this.node.code;
                    this.editCategory = this.node.category;
                }
                this.isEditMode = !this.isEditMode;
            }
        },
        // 上移節點
        moveUp() {
            this.$emit('beforeModifyNode', 'moveup');
            const index = this.siblings.indexOf(this.node);
            if (index > 0) {
                // 移動節點，將其與前一個節點交換
                this.siblings.splice(index, 1);
                this.siblings.splice(index - 1, 0, this.node);
            }
        },
        // 下移節點
        moveDown() {
            this.$emit('beforeModifyNode', 'movedown');
            const index = this.siblings.indexOf(this.node);
            if (index < this.siblings.length - 1) {
                // 移動節點，將其與下一個節點交換
                this.siblings.splice(index, 1);
                this.siblings.splice(index + 1, 0, this.node);
            }
        },
        // 刪除節點
        deleteNode() {
            this.$emit('delete', [{
                code:this.node.code, 
                category:this.node.category,
                isother:this.node.isother,
            }])
        },
        onDelete(data) {
            this.$emit('delete', [
                {
                    code:this.node.code, 
                    category:this.node.category
                }
            , ...data])
        },
        // 編輯子節點事件
        onEditCoverage(data) {
            this.$emit('editCoverage', [
                {
                    code:this.node.code, 
                    category:this.node.category
                }
            , ...data])
        },
        onBeforeModifyNode(type) {
            this.$emit('beforeModifyNode', type);
        }
    },
    mounted() { 
       this.isExpanded = this.expanded;
    },
};
</script>

<style lang="scss" scoped>
.w-30 {
    width: 30px;
}
.h-26 {
    height: 26px;
}
.lh-18 {
    line-height: 18px;
}
</style>